export const FETCHED_ROLES = 'FETCHED_ROLES';
export const FETCHED_PERMISSIONS = 'FETCHED_PERMISSIONS';
export const FETCHED_ROLES_PERMISSIONS = 'FETCHED_ROLES_PERMISSIONS';
export const CHANGE_ROLE_PERMISSION = 'CHANGE_ROLE_PERMISSION';
export const UPDATED_ROLES_PERMISSIONS = 'UPDATED_ROLES_PERMISSIONS';
export const FETCHED_PERMISSIONS_GROUPS = 'FETCHED_PERMISSIONS_GROUPS';


// WEBPACK FOOTER //
// ./src/containers/roles/types.js